import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function AC_curriculum_page() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className='fs-5'>1. Introduction to AutoCad</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          AutoCAD concepts, AutoCAD tools & scope, Designing & drafting importance, Preliminary & Drafting settings in AutoCAD, Co-ordinate system & coursework, Requirements of tools & views of D.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className='fs-5'>2. Geometry Development</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Geometry creation, Object & properties & importance, Modification & coursework.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className='fs-5'>3. Advanced Function</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          AutoCAD 1 -Setting dimensions & text & leader, Creating tables & linking & extracting data, Parametric constraint, Design center and course work, Block and dynamic blocks.
          <br></br>AutoCAD 2 - Attributes & layer management, Templates generation, Layout & viewports, Autocad plot styles.
          <br></br>AutoCAD 3 - System requirements & installation, Starting Autocad 2023 & user interfaces, Workspaces (colour/applications/ graphic/different bars/ shortcuts and commands list / 3D).
           </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className='fs-5'>4. Modeling in Inventor</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Product development cycle management, CAD solution providers, Autodesk inventor & UI Autodesk (professional) Developing advance shapes & primitive shapes.  
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
        >
          <Typography className='fs-5'>5. Sheet Metal Design</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Design settings & sheet metal parameters, developing base & secondary features, Cutting & stamping operations.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel6bh-content"
          id="panel6bh-header"
        >
          <Typography className='fs-5'>6. Assembly Design</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Design & approaches, Constraints & joints, Content Centre & duplicating components.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel7bh-content"
          id="panel7bh-header"
        >
          <Typography className='fs-5'>7. Drafting in Inventor</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Need of documentation, drafting setup with standards, creating part drafting, Define GD& T, Creating assembly drafting & part list.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel8bh-content"
          id="panel8bh-header"
        >
          <Typography className='fs-5'>8. MINOR & MAJOR PROJECT</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Minor Project, Major Project, Project Overview.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
